export default "__VITE_ASSET__C9a8Q1ra__"